import { useState } from "react";
import { FormDialog } from "flux";
import { BaseDialogProps } from "@adora/shared/contexts/dialog-context";
import ModelTraining from "../../utils/model-training";
import { useToast } from "@adora/shared/hooks/use-toast";
import BulkGenerationForm from "./form";

interface BulkGenerationDialogProps extends BaseDialogProps {
  brandId: number;
}

const BulkGenerationDialog: React.FC<BulkGenerationDialogProps> = ({ brandId, open, onClose }) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { openToast } = useToast();

  const handleGeneration = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!selectedFile) return;

    setSubmitting(true);
    const { uploadCsv, triggerBulkGeneration } = ModelTraining();

    const datasetPath = await uploadCsv({
      brandId,
      file: selectedFile
    });

    const response = await triggerBulkGeneration({
      datasetPath,
      brandId
    });
    response.match(
      (error) => {
        if (error.tag == "validationError") {
          error.errors.map((message) => openToast(message));
        } else {
          openToast("An unknown error occured");
        }
        setSubmitting(false);
      },
      () => {
        setSubmitting(false);
        onClose(true);
      }
    );
  };

  const handleFileSelect = (file: File) => {
    setSelectedFile(file);
  };

  return (
    <FormDialog
      title="Bulk Image Generation"
      description={"Kick off bulk jobs for image generation"}
      open={open}
      onClose={onClose}
      onSubmit={handleGeneration}
      primaryButtonText="Submit"
      isPrimaryButtonDisabled={submitting}
      dataDogIdentifier="bulk image generation"
    >
      <BulkGenerationForm onFileSelect={handleFileSelect} />
    </FormDialog>
  );
};

export default BulkGenerationDialog;
